export default "__VITE_ASSET__DzEW2AJI__"